var cities = ["amsterdam", "arlington", "atlanta", "austin", "bangkok", "boston", 
					"brisbane", "charlotte", "detroit", "halifax", "hong kong", "hongkong", 
					"houston", "kualalumpur", "kuala lumpur", "las vegas", "lasvegas", 
					"los angeles","losangeles","manila", "mexico city", "mexicocity", "miami", "moncton", "montreal", "munich", 
					"new york", "newyork", "orlando", "portland", "prague", "sandiego", 
					"san diego", "singapore", "stockholm","sydney", "toronto", "tuscon", "vancouver", 
					"washingtondc", "washington dc"];///GET this list FROM JEFF
var instructors = ["Bravado","Cajun","Calabrese","Charmer","Tenmagnet","Dan Wildcard","Erik Royale","Fader","Flash","JC","jc","Helicase","Hootie","Jasper","Lemonjacket","Nick Savoy","Rio","Samurai","Scumbadger","Sterling","Venture","Vici","Vox","Vybe","bravado","cajun","calabrese","charmer","tenmagnet","dan wildcard","erik royale","fader","flash","jc","helicase","hootie","jasper","lemonjacket","nick savoy","rio","samurai","scumbadger","sterling","venture","vici","vox","vybe"];//get this list from jeff
	
var width = $(window).width();
var skusWithProductInfo = {};
var listOfAvailableCities = [];
function isBootcampCity(cityName){

	if($.inArray(cityName, cities) != -1){ 
		return true;
	}
	return false;
}

function isInstructor(instructorName){
	if($.inArray(instructorName, instructors) != -1){ 
		return true;
	}
	return false;
	
}

function toUpper(str){
    return str.replace(/\b[a-z]/g, function(letter) {return letter.toUpperCase();});
}

String.prototype.endsWith = function(suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};

function updateTable(){
	currentProductsToDisplay = skusWithProductInfo;
	displayBootcampTable( currentProductsToDisplay );
}

$(document).ready(function () {
	$('#sort-by-city,#sort-by-instructor').change(function() {
		
		$("#full_live_training_table").hide();
		$("#loading_table").show();
		
		var selectedCity 		= $("#sort-by-city").val();
		var selectedInstructor 	= $("#sort-by-instructor").val();
		keepRowsContainingTheseTags(selectedCity, selectedInstructor);
		//sortNewTable();
		$("#loading_table").hide();
		$("#full_live_training_table").show();
	});

});



function keepRowsContainingTheseTags(selectedCity, selectedInstructor){
	var counter = 0;
	$('#bootcamp-table > tbody  > tr').not(':first').each(function() {
		var tagsArr = $(this).attr('data-tags').split(",");
		if(displayRow(selectedCity, selectedInstructor, tagsArr)){
			counter = counter + 1;
			if(counter%2==0)
				$(this).removeClass().addClass("oddRow");
			else
				$(this).removeClass().addClass("evenRow");
			$(this).show();
		}else{
			$(this).hide();
		}
	});
}

function displayRow(selectedCity, selectedInstructor, tagsArr){
	if(( (selectedCity=="All") ? true : isInTags(selectedCity, tagsArr)) 
		&& ( selectedInstructor=="All" ? true : isInTags(selectedInstructor, tagsArr) )){
		return true;
	}
	return false;
}
function isInTags(value, tagArray){
	for (var i in tagArr) {
		if(value == tagArr[i])
			return true;
	}
	return false;
}

function updateBootcampTable(selectedCity, selectedInstructor){
	var currentProductsToDisplay = {};
	for(var key in skusWithProductInfo){
		var aProduct = skusWithProductInfo[key];
		var tagsArr = getTags(aProduct);
		var productHasSelectedCity = isPartOfProduct(selectedCity, tagsArr);
		var productHasSelectedInstructor = isPartOfProduct(selectedInstructor, tagsArr);
	
		if(productHasSelectedCity && productHasSelectedInstructor){
			currentProductsToDisplay[aProduct[0]] = [aProduct[0],aProduct[1],aProduct[2],aProduct[3],aProduct[4]];
		}
	}
	displayBootcampTable(currentProductsToDisplay);
}

function getTags(aProduct){
	return aProduct[4].split("|");
}

function isPartOfProduct(selected, tagsArr){
	return (isInTags(selected, tagsArr)||selected ==='All')?true : false;
}

function isInTags(str, tagsArr){
	for(var index in tagsArr){
		var aTag = tagsArr[index];
		if(aTag === str){
			return true;	
		}
	}
	return false;
}

function displayBootcampTable(dictionary){

		var sortedSkus = [];
		for(var key in dictionary) {
			sortedSkus[sortedSkus.length] = key;
		}
		var rowHtml  = '';
		rowHtml += '<tr><th style="width:75%"><span>Event</span></th><th>Seats Left</th><th>Reserve NOW!</th></tr>';

		if(sortedSkus.length == 0){
			$("#bootcamp-table").html(rowHtml);
			return;
		}
		sortedSkus.sort();

		for (i = 0; i < sortedSkus.length; i++) {
			var productArray = dictionary[sortedSkus[i]];
			var sku = productArray[0];
			var productTitle = productArray[1];
			var inventoryQuantity = productArray[2];
			var productUrl = productArray[3];
			var tags = productArray[4];
			
			if(sku.endsWith("SEM")){
				continue;
			}
			rowHtml += '<tr>';
			rowHtml += '<td class="left-align">';
			rowHtml += '<a href="'+productUrl+'">'+productTitle+'</a>';
			rowHtml += '</td>';
			rowHtml += '<td class="center-align">';
			rowHtml += (inventoryQuantity==='0'?'SOLD OUT':inventoryQuantity);
			rowHtml += '</td>';
			rowHtml += '<td class="center-align">';
			rowHtml += '<a href="'+productUrl+'">';
			
			
			//rowHtml += '<span data-fancybox-href="#product-2201386181" class="quick_shop action_button" data-gallery="product-2201386181-gallery" style="display: none;">';
			//rowHtml += 'Reserve Seats';
			//rowHtml += '</span>';
			
			
			
			
			
			
			
			rowHtml +='<input class="btn" type="submit" value="Reserve Seats" style="margin-bottom: 5px !important"></td>';
			rowHtml += '</a>';
			rowHtml += '</td>';
			rowHtml += '</tr>';
			$("#bootcamp-table").html(rowHtml);
		}	
}
function updateUpcomingEvents(dictionary){

		var sortedSkus = [];
		for(var key in dictionary) {
				if (key.indexOf('PARENT') === -1 || key.indexOf('SEM') > -1) {
					delete dictionary[key];
				}
			sortedSkus[sortedSkus.length] = dictionary[key];
		}

		var rowHtml  = '';
		rowHtml+='<div>';
		rowHtml+='<div style="vertical-align: top;font-size:25;padding-bottom:0px;" class="upcoming-events-homepage-row-top">';
		rowHtml+='<div style="vertical-align: top;font-weight: 900;font-size: 25px;font-family: "Roboto";" class="upcoming-events-homepage-row-top-left">Upcoming Events</div>';
		rowHtml+="<div class=\"upcoming-events-homepage-row-top-right calendar\"><img style=\"height:28px\" src=\"//cdn.shopify.com/s/files/1/0972/5696/t/34/assets/icon-calendar.png?v=70912332647245208601453519604\"></div>";
		rowHtml+='</div>';
		rowHtml+='</div>';
		
		
		sortedSkus.sort();
		var counter = 0;
		var upcomingEvents = [];
		for (var i = 0; i < sortedSkus.length; i++) {			
			if (width >= 768 && width < 1200 && i === 4 ) {
				break;
			}

			if (width <= 959 && width >= 768 && i === 3) {
				break;
			}

		
			var productArray = sortedSkus[i];
			var sku = productArray[0];
			var productTitle = productArray[1];
			var inventoryQuantity = productArray[2];
			var productUrl = productArray[3];
			var tags = productArray[4];
			var myarr = productTitle.split(/,(.+)?/);
			var finalTitle = myarr[1]+":  "+myarr[0];

			// if(sku.endsWith("SEM")){
			// 	continue;
			// }
			counter = counter + 1;
			
					
			rowHtml+='<div class="verticalLine"></div>';
			rowHtml+='<a style="color:black;text-decoration:none;" href="'+productUrl+'">';
			rowHtml+='<div class="upcoming-events-homepage-row">';
				rowHtml+='<div class="upcoming-events-homepage-row-top">';
					rowHtml+='<div style="width:100%" class="upcoming-events-homepage-row-top-left no-wrap-product-title">';
						rowHtml+='<div style="white-space:nowrap; overflow:hidden;">'+finalTitle+'</div>';
					rowHtml+='</div>';
				rowHtml+='</div>';
				rowHtml+='<div class="upcoming-events-homepage-row-bottom"></div>';
			rowHtml+='</div>';
			rowHtml+='</a>';
			
			if(counter==5) break;

		}
		rowHtml+='<div class="upcoming-events-homepage-row world-wide-events" style="text-align:center; background-color:#CCDADB;overflow:hidden">';
			rowHtml+='<span style="display: inline-block;height: 100%;vertical-align: middle;">';
			rowHtml+='<img style="height:20px;vertical-align: sub;" src="https://cdn.shopify.com/s/files/1/0972/5696/t/4/assets/icon-world.png?15562592818159071336">';
			rowHtml+='</span>';
			rowHtml+=' <span style="font-weight:bold;font-size:15px;margin-left:10px;"><a style="color:black" href="/collections/live-training">View Worldwide Events</a></span>';
		rowHtml+='</div>';

		if (width >= 768 && width < 1200) {
			$("#upcoming-events-on-homepage-row:last-child").hide();
		}
		$("#upcoming-events-on-homepage").html(rowHtml);

}


function sortNewTable(){
	var $table=$('#bootcamp-table');
	var rows = $table.find('tr').get();
	rows.sort(function(a, b) {
		var keyA = $(a).attr('data-sku');
		var keyB = $(b).attr('data-sku');
		if (keyA > keyB) return 1;
		if (keyA < keyB) return -1;
		return 0;
	});
	$.each(rows, function(index, row) {
		$table.children('tbody').append(row);
	});

	$("#loading_table").hide();
	$("#full_live_training_table").show();
	
}

// IE browsers

function GetIEVersion() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0) 
    return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./)) 
    return 11;

  else
    return 0; //It is not IE
}

if (GetIEVersion() > 0) {
   $('.world-wide-events .upcoming-events-homepage-row').css('width', '9');
   // $('.world-wide-events > span > a').css('');
   $('.world-wide-events > span > img').css('top', '-4');
 }




